/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: string;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AggregatedQuizQuestionScore = {
  __typename?: "AggregatedQuizQuestionScore";
  count: Scalars["Int"];
  option: QuizAnswerOption;
  totalWeight: Scalars["Float"];
};

export type AggregatedTriviaQuestionScore = {
  __typename?: "AggregatedTriviaQuestionScore";
  count: Scalars["Int"];
  option: TriviaAnswerOption;
};

export type Attribute = {
  __typename?: "Attribute";
  createdAt: Scalars["DateTime"];
  customRatingQuestion?: Maybe<CustomRatingQuestion>;
  customText?: Maybe<Scalars["String"]>;
  id: Scalars["UUID"];
  image?: Maybe<LibraryImage>;
  isCorrect: Scalars["Boolean"];
  name: Scalars["String"];
  points: Scalars["Int"];
  showImageAndText: Scalars["Boolean"];
  slug: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
};

export type AttributeCreateInput = {
  customText?: InputMaybe<Scalars["String"]>;
  imageId?: InputMaybe<Scalars["String"]>;
  isCorrect?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
};

export type AttributeResult = {
  __typename?: "AttributeResult";
  attribute: Attribute;
  totalScore: Scalars["Int"];
};

export type AttributeScore = {
  __typename?: "AttributeScore";
  attribute: Attribute;
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  score: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
};

export type AttributeScoreInput = {
  attributeId: Scalars["UUID"];
  score: Scalars["Int"];
};

export type AttributeUpdateInput = {
  /** Set to null to remove the custom rating question */
  customRatingQuestion?: InputMaybe<CustomRatingQuestionUpdateInput>;
  customText?: InputMaybe<Scalars["String"]>;
  imageId?: InputMaybe<Scalars["String"]>;
  isCorrect?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  points?: InputMaybe<Scalars["Int"]>;
  showImageAndText?: InputMaybe<Scalars["Boolean"]>;
};

export type CheckoutSession = {
  __typename?: "CheckoutSession";
  id: Scalars["String"];
};

export type ConfigurationUnion =
  | QuickRankConfiguration
  | QuizConfiguration
  | RankifierConfiguration
  | SwiperConfiguration
  | TriviaConfiguration
  | WordleConfiguration
  | WordopolisConfiguration;

export type CreateDirectoryInput = {
  name: Scalars["String"];
  parentDirectoryId?: InputMaybe<Scalars["UUID"]>;
};

export type CreateLibraryImagesInput = {
  files: Array<Scalars["Upload"]>;
  kind: LibraryImageKind;
};

export type CreateProjectInput = {
  customEndScreenConfiguration?: InputMaybe<CustomEndScreenConfigurationInput>;
  directoryId?: InputMaybe<Scalars["UUID"]>;
  hideDatagameBranding?: InputMaybe<Scalars["Boolean"]>;
  hideSummaryPage?: InputMaybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  showCustomEndScreen?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<ProjectStatus>;
};

export type CreateVideoInput = {
  file: Scalars["Upload"];
};

export type CustomEndScreenConfiguration = {
  __typename?: "CustomEndScreenConfiguration";
  backgroundColor: Scalars["String"];
  backgroundImage?: Maybe<LibraryImage>;
  createdAt: Scalars["DateTime"];
  description: Scalars["String"];
  descriptionColor: Scalars["String"];
  id: Scalars["UUID"];
  logo?: Maybe<LibraryImage>;
  mainHeader: Scalars["String"];
  mainHeaderColor: Scalars["String"];
  title: Scalars["String"];
  titleColor: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type CustomEndScreenConfigurationInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["UUID"]>;
  description?: InputMaybe<Scalars["String"]>;
  descriptionColor?: InputMaybe<Scalars["String"]>;
  logoId?: InputMaybe<Scalars["UUID"]>;
  mainHeader?: InputMaybe<Scalars["String"]>;
  mainHeaderColor?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  titleColor?: InputMaybe<Scalars["String"]>;
};

export type CustomEndScreenConfigurationUpdateInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["UUID"]>;
  description?: InputMaybe<Scalars["String"]>;
  descriptionColor?: InputMaybe<Scalars["String"]>;
  mainHeader?: InputMaybe<Scalars["String"]>;
  mainHeaderColor?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  titleColor?: InputMaybe<Scalars["String"]>;
};

export type CustomRatingQuestion = {
  __typename?: "CustomRatingQuestion";
  leftLabel: Scalars["String"];
  question: Scalars["String"];
  rightLabel: Scalars["String"];
  scaleSize: Scalars["Int"];
};

export type CustomRatingQuestionUpdateInput = {
  leftLabel?: InputMaybe<Scalars["String"]>;
  question?: InputMaybe<Scalars["String"]>;
  rightLabel?: InputMaybe<Scalars["String"]>;
  scaleSize?: InputMaybe<Scalars["Int"]>;
};

export type DemographicAnswerOption = {
  __typename?: "DemographicAnswerOption";
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  orderIndex: Scalars["Int"];
  text: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  value: Scalars["String"];
};

export type DemographicAnswerStat = {
  __typename?: "DemographicAnswerStat";
  count: Scalars["Int"];
  optionId: Scalars["String"];
  optionText: Scalars["String"];
  percentage: Scalars["Float"];
};

export type DemographicNumberStat = {
  __typename?: "DemographicNumberStat";
  average: Scalars["Float"];
  count: Scalars["Int"];
  max: Scalars["Float"];
  min: Scalars["Float"];
};

export type DemographicQuestion = {
  __typename?: "DemographicQuestion";
  answerOptions: Array<DemographicAnswerOption>;
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  isRequired: Scalars["Boolean"];
  orderIndex: Scalars["Int"];
  questionText: Scalars["String"];
  questionType: DemographicQuestionType;
  updatedAt: Scalars["DateTime"];
};

export enum DemographicQuestionType {
  MultiSelect = "MULTI_SELECT",
  NumberInput = "NUMBER_INPUT",
  Radio = "RADIO",
  SingleSelect = "SINGLE_SELECT",
  TextInput = "TEXT_INPUT",
}

export type DemographicReport = {
  __typename?: "DemographicReport";
  demographicResults: Array<DemographicReportLine>;
  totalResponses: Scalars["Int"];
};

export type DemographicReportLine = {
  __typename?: "DemographicReportLine";
  answerStats: Array<DemographicAnswerStat>;
  numberStats?: Maybe<DemographicNumberStat>;
  question: DemographicQuestion;
  textStats: Array<DemographicTextStat>;
  totalResponses: Scalars["Int"];
};

export type DemographicResponse = {
  __typename?: "DemographicResponse";
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  numberValue?: Maybe<Scalars["Int"]>;
  questionId: Scalars["ID"];
  quizSessionId: Scalars["ID"];
  selectedOptionIds: Array<Scalars["ID"]>;
  textValue?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type DemographicResponseInput = {
  numberValue?: InputMaybe<Scalars["Int"]>;
  questionId: Scalars["ID"];
  selectedOptionIds?: InputMaybe<Array<Scalars["ID"]>>;
  textValue?: InputMaybe<Scalars["String"]>;
};

export type DemographicTextStat = {
  __typename?: "DemographicTextStat";
  count: Scalars["Int"];
  value: Scalars["String"];
};

export type Directory = {
  __typename?: "Directory";
  createdAt: Scalars["DateTime"];
  default: Scalars["Boolean"];
  id: Scalars["UUID"];
  name: Scalars["String"];
  parentDirectory?: Maybe<Directory>;
  parentDirectoryId?: Maybe<Scalars["UUID"]>;
  updatedAt: Scalars["DateTime"];
};

export type FeedbackPage = {
  __typename?: "FeedbackPage";
  backgroundColor: Scalars["String"];
  backgroundImage?: Maybe<LibraryImage>;
  confirmation: Scalars["String"];
  confirmationColor: Scalars["String"];
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  instructionLine: Scalars["String"];
  instructionLineColor: Scalars["String"];
  submitButton: Scalars["String"];
  submitButtonColor: Scalars["String"];
  textBoxPrompt: Scalars["String"];
  textBoxPromptColor: Scalars["String"];
  title: Scalars["String"];
  titleColor: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type FeedbackPageUpdateInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["UUID"]>;
  confirmation?: InputMaybe<Scalars["String"]>;
  confirmationColor?: InputMaybe<Scalars["String"]>;
  instructionLine?: InputMaybe<Scalars["String"]>;
  instructionLineColor?: InputMaybe<Scalars["String"]>;
  submitButton?: InputMaybe<Scalars["String"]>;
  submitButtonColor?: InputMaybe<Scalars["String"]>;
  textBoxPrompt?: InputMaybe<Scalars["String"]>;
  textBoxPromptColor?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  titleColor?: InputMaybe<Scalars["String"]>;
};

export type Game = {
  __typename?: "Game";
  configuration: ConfigurationUnion;
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  kind: GameKind;
  name: Scalars["String"];
  responseCount: Scalars["Int"];
  responses: Array<Response>;
  updatedAt: Scalars["DateTime"];
};

export type GameCreateInput = {
  kind: GameKind;
  name: Scalars["String"];
  projectId: Scalars["UUID"];
};

/** Type of a game */
export enum GameKind {
  QuickRank = "QUICK_RANK",
  QuizGame = "QUIZ_GAME",
  Rankifier = "RANKIFIER",
  Swiper = "SWIPER",
  Trivia = "TRIVIA",
  Wordle = "WORDLE",
  Wordopolis = "WORDOPOLIS",
}

export type GameResultsConfiguration = {
  __typename?: "GameResultsConfiguration";
  backgroundColor: Scalars["String"];
  backgroundImage?: Maybe<LibraryImage>;
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  scoreTag_0_20: Scalars["String"];
  scoreTag_21_40: Scalars["String"];
  scoreTag_41_60: Scalars["String"];
  scoreTag_61_80: Scalars["String"];
  scoreTag_81_100: Scalars["String"];
  scoreTitle_0_20: Scalars["String"];
  scoreTitle_21_40: Scalars["String"];
  scoreTitle_41_60: Scalars["String"];
  scoreTitle_61_80: Scalars["String"];
  scoreTitle_81_100: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type GameResultsConfigurationUpdateInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["UUID"]>;
  scoreTag_0_20?: InputMaybe<Scalars["String"]>;
  scoreTag_21_40?: InputMaybe<Scalars["String"]>;
  scoreTag_41_60?: InputMaybe<Scalars["String"]>;
  scoreTag_61_80?: InputMaybe<Scalars["String"]>;
  scoreTag_81_100?: InputMaybe<Scalars["String"]>;
  scoreTitle_0_20?: InputMaybe<Scalars["String"]>;
  scoreTitle_21_40?: InputMaybe<Scalars["String"]>;
  scoreTitle_41_60?: InputMaybe<Scalars["String"]>;
  scoreTitle_61_80?: InputMaybe<Scalars["String"]>;
  scoreTitle_81_100?: InputMaybe<Scalars["String"]>;
};

export type GameUpdateInput = {
  name: Scalars["String"];
};

export type GameVisuals = {
  __typename?: "GameVisuals";
  absentLetter: Scalars["String"];
  backgroundColor: Scalars["String"];
  backgroundImage?: Maybe<LibraryImage>;
  backgroundNegativeColor: Scalars["String"];
  backgroundPositiveColor: Scalars["String"];
  cardBackImage?: Maybe<LibraryImage>;
  cardFrontImage?: Maybe<LibraryImage>;
  cardStringColor: Scalars["String"];
  correctLetter: Scalars["String"];
  createdAt: Scalars["DateTime"];
  defaultLetter: Scalars["String"];
  iconSet: IconSet;
  id: Scalars["UUID"];
  negativeColor: Scalars["String"];
  positiveColor: Scalars["String"];
  presentLetter: Scalars["String"];
  questionStringColor: Scalars["String"];
  showIcons: Scalars["Boolean"];
  themeColor: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type GameVisualsUpdateInput = {
  absentLetter?: InputMaybe<Scalars["String"]>;
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["String"]>;
  backgroundNegativeColor?: InputMaybe<Scalars["String"]>;
  backgroundPositiveColor?: InputMaybe<Scalars["String"]>;
  cardBackImageId?: InputMaybe<Scalars["String"]>;
  cardFrontImageId?: InputMaybe<Scalars["String"]>;
  cardStringColor?: InputMaybe<Scalars["String"]>;
  correctLetter?: InputMaybe<Scalars["String"]>;
  defaultLetter?: InputMaybe<Scalars["String"]>;
  iconSet?: InputMaybe<IconSet>;
  negativeColor?: InputMaybe<Scalars["String"]>;
  positiveColor?: InputMaybe<Scalars["String"]>;
  presentLetter?: InputMaybe<Scalars["String"]>;
  questionStringColor?: InputMaybe<Scalars["String"]>;
  showIcons?: InputMaybe<Scalars["Boolean"]>;
  themeColor?: InputMaybe<Scalars["String"]>;
};

/** The set of icons to use for a game */
export enum IconSet {
  Default = "DEFAULT",
  Faces = "FACES",
  Hearts = "HEARTS",
  PlusAndMinus = "PLUS_AND_MINUS",
  ThumbsUpAndDown = "THUMBS_UP_AND_DOWN",
}

export type LeaderboardConfiguration = {
  __typename?: "LeaderboardConfiguration";
  backgroundColor: Scalars["String"];
  backgroundImage?: Maybe<LibraryImage>;
  createdAt: Scalars["DateTime"];
  header: Scalars["String"];
  headerColor: Scalars["String"];
  id: Scalars["UUID"];
  nicknameLabel: Scalars["String"];
  nicknameQuestion: Scalars["String"];
  nicknameQuestionColor: Scalars["String"];
  numberOfPlayers: Scalars["Int"];
  showTimer: Scalars["Boolean"];
  subheader: Scalars["String"];
  subheaderColor: Scalars["String"];
  tableNicknameLabel: Scalars["String"];
  tableScoreLabel: Scalars["String"];
  tableTimeLabel: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type LeaderboardConfigurationUpdateInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["UUID"]>;
  header?: InputMaybe<Scalars["String"]>;
  headerColor?: InputMaybe<Scalars["String"]>;
  nicknameLabel?: InputMaybe<Scalars["String"]>;
  nicknameQuestion?: InputMaybe<Scalars["String"]>;
  nicknameQuestionColor?: InputMaybe<Scalars["String"]>;
  numberOfPlayers?: InputMaybe<Scalars["Int"]>;
  showTimer?: InputMaybe<Scalars["Boolean"]>;
  subheader?: InputMaybe<Scalars["String"]>;
  subheaderColor?: InputMaybe<Scalars["String"]>;
  tableNicknameLabel?: InputMaybe<Scalars["String"]>;
  tableScoreLabel?: InputMaybe<Scalars["String"]>;
  tableTimeLabel?: InputMaybe<Scalars["String"]>;
};

export type LeaderboardRow = {
  __typename?: "LeaderboardRow";
  id: Scalars["UUID"];
  nickname: Scalars["String"];
  points: Scalars["Int"];
  rank: Scalars["Int"];
  timeInMs: Scalars["Int"];
};

export type LibraryImage = {
  __typename?: "LibraryImage";
  createdAt: Scalars["DateTime"];
  extension: Scalars["String"];
  id: Scalars["UUID"];
  isGlobal: Scalars["Boolean"];
  kind: LibraryImageKind;
  name: Scalars["String"];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars["UUID"]>;
  updatedAt: Scalars["DateTime"];
  url: Scalars["String"];
};

export enum LibraryImageKind {
  Background = "BACKGROUND",
  CardBack = "CARD_BACK",
  CardFront = "CARD_FRONT",
  GameBoard = "GAME_BOARD",
  Logo = "LOGO",
  Poster = "POSTER",
  TriviaImage = "TRIVIA_IMAGE",
}

export type Mutation = {
  __typename?: "Mutation";
  attributeCreate: Attribute;
  attributeDelete: Attribute;
  attributeUpdate: Attribute;
  completeQuizSession: QuizSession;
  createQuizSession: QuizSession;
  customEndScreenConfigurationUpdate: CustomEndScreenConfiguration;
  directoryCreate: Directory;
  directoryDelete: Directory;
  directoryUpdate: Directory;
  feedbackPageUpdate: FeedbackPage;
  gameAddRating: Game;
  gameCreate: Game;
  gameDelete: Game;
  gameResultsUpdate: GameResultsConfiguration;
  gameUpdate: Game;
  gameVisualsUpdate: GameVisuals;
  leaderboardConfigurationUpdate: LeaderboardConfiguration;
  libraryImageCreate: Array<LibraryImage>;
  libraryImageDelete: LibraryImage;
  projectCopy: Project;
  projectCreate: Project;
  projectDelete: Project;
  projectDeleteData: Project;
  projectUpdate: Project;
  quickRankConfigurationUpdate: QuickRankConfiguration;
  rankifierConfigurationUpdate: RankifierConfiguration;
  responseCreate: Response;
  signIn: SignInResponse;
  signInWithCode: SignInResponse;
  signUp: User;
  stripeCheckoutCreate: CheckoutSession;
  stripePortalSessionCreate: PortalSession;
  submitDemographicResponses: Array<DemographicResponse>;
  swiperConfigurationUpdate: SwiperConfiguration;
  triviaAnswerOptionCreate: TriviaAnswerOption;
  triviaAnswerOptionDelete: TriviaQuestion;
  triviaAnswerOptionUpdate: TriviaAnswerOption;
  triviaConfigurationUpdate: TriviaConfiguration;
  triviaQuestionCreate: TriviaQuestion;
  triviaQuestionDelete: TriviaQuestion;
  triviaQuestionUpdate: TriviaQuestion;
  updateQuizSession: QuizSession;
  userDelete: User;
  userDeleteCurrent: User;
  userGrantAdmin: User;
  userInvite: User;
  userRequestPasswordReset: Scalars["Boolean"];
  userResendInvitation: User;
  userRevokeAdmin: User;
  userUpdate: User;
  userUpdatePassword: User;
  videoCreate: Video;
  videoDelete: Video;
  welcomePageUpdate: WelcomePage;
  wordleConfigurationUpdate: WordleConfiguration;
  wordopolisConfigurationUpdate: WordopolisConfiguration;
};

export type MutationAttributeCreateArgs = {
  data: AttributeCreateInput;
  gameId: Scalars["String"];
};

export type MutationAttributeDeleteArgs = {
  attributeId: Scalars["String"];
};

export type MutationAttributeUpdateArgs = {
  attributeId: Scalars["String"];
  data: AttributeUpdateInput;
};

export type MutationCompleteQuizSessionArgs = {
  sessionId: Scalars["String"];
};

export type MutationCreateQuizSessionArgs = {
  data: QuizSessionCreateInput;
};

export type MutationCustomEndScreenConfigurationUpdateArgs = {
  customEndScreenConfigurationId: Scalars["String"];
  data: CustomEndScreenConfigurationUpdateInput;
};

export type MutationDirectoryCreateArgs = {
  data: CreateDirectoryInput;
};

export type MutationDirectoryDeleteArgs = {
  directoryId: Scalars["String"];
};

export type MutationDirectoryUpdateArgs = {
  data: UpdateDirectoryInput;
  directoryId: Scalars["String"];
};

export type MutationFeedbackPageUpdateArgs = {
  data: FeedbackPageUpdateInput;
  feedbackPageId: Scalars["String"];
};

export type MutationGameAddRatingArgs = {
  gameId: Scalars["String"];
  rating: Scalars["Int"];
};

export type MutationGameCreateArgs = {
  data: GameCreateInput;
};

export type MutationGameDeleteArgs = {
  gameId: Scalars["String"];
};

export type MutationGameResultsUpdateArgs = {
  data: GameResultsConfigurationUpdateInput;
  gameResultsId: Scalars["String"];
};

export type MutationGameUpdateArgs = {
  data: GameUpdateInput;
  gameId: Scalars["String"];
};

export type MutationGameVisualsUpdateArgs = {
  data: GameVisualsUpdateInput;
  gameVisualsId: Scalars["String"];
};

export type MutationLeaderboardConfigurationUpdateArgs = {
  data: LeaderboardConfigurationUpdateInput;
  leaderboardConfigurationId: Scalars["String"];
};

export type MutationLibraryImageCreateArgs = {
  input: CreateLibraryImagesInput;
};

export type MutationLibraryImageDeleteArgs = {
  libraryImageId: Scalars["UUID"];
};

export type MutationProjectCopyArgs = {
  directoryId?: InputMaybe<Scalars["String"]>;
  projectId: Scalars["String"];
};

export type MutationProjectCreateArgs = {
  data: CreateProjectInput;
};

export type MutationProjectDeleteArgs = {
  projectId: Scalars["String"];
};

export type MutationProjectDeleteDataArgs = {
  projectId: Scalars["String"];
};

export type MutationProjectUpdateArgs = {
  data: ProjectUpdateInput;
  projectId: Scalars["String"];
};

export type MutationQuickRankConfigurationUpdateArgs = {
  data: QuickRankConfigurationUpdateInput;
  quickRankConfigurationId: Scalars["String"];
};

export type MutationRankifierConfigurationUpdateArgs = {
  data: RankifierConfigurationUpdateInput;
  rankifierConfigurationId: Scalars["String"];
};

export type MutationResponseCreateArgs = {
  data: ResponseCreateInput;
};

export type MutationSignInArgs = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type MutationSignInWithCodeArgs = {
  code: Scalars["String"];
};

export type MutationSignUpArgs = {
  data: SignUpInput;
};

export type MutationStripeCheckoutCreateArgs = {
  priceId: Scalars["String"];
};

export type MutationSubmitDemographicResponsesArgs = {
  responses: Array<DemographicResponseInput>;
  sessionId: Scalars["String"];
};

export type MutationSwiperConfigurationUpdateArgs = {
  data: SwiperConfigurationUpdateInput;
  swiperConfigurationId: Scalars["String"];
};

export type MutationTriviaAnswerOptionCreateArgs = {
  data: TriviaAnswerOptionCreateInput;
  triviaQuestionId: Scalars["String"];
};

export type MutationTriviaAnswerOptionDeleteArgs = {
  triviaAnswerOptionId: Scalars["String"];
};

export type MutationTriviaAnswerOptionUpdateArgs = {
  data: TriviaAnswerOptionUpdateInput;
  triviaAnswerOptionId: Scalars["String"];
};

export type MutationTriviaConfigurationUpdateArgs = {
  data: TriviaConfigurationUpdateInput;
  triviaConfigurationId: Scalars["String"];
};

export type MutationTriviaQuestionCreateArgs = {
  data: TriviaQuestionCreateInput;
  triviaConfigurationId: Scalars["String"];
};

export type MutationTriviaQuestionDeleteArgs = {
  triviaQuestionId: Scalars["String"];
};

export type MutationTriviaQuestionUpdateArgs = {
  data: TriviaQuestionUpdateInput;
  triviaQuestionId: Scalars["String"];
};

export type MutationUpdateQuizSessionArgs = {
  data: QuizSessionUpdateInput;
};

export type MutationUserDeleteArgs = {
  userId: Scalars["String"];
};

export type MutationUserGrantAdminArgs = {
  userId: Scalars["String"];
};

export type MutationUserInviteArgs = {
  email: Scalars["String"];
};

export type MutationUserRequestPasswordResetArgs = {
  email: Scalars["String"];
  token: Scalars["String"];
};

export type MutationUserResendInvitationArgs = {
  userId: Scalars["String"];
};

export type MutationUserRevokeAdminArgs = {
  userId: Scalars["String"];
};

export type MutationUserUpdateArgs = {
  data: UserUpdateInput;
};

export type MutationUserUpdatePasswordArgs = {
  data: UserUpdatePasswordInput;
};

export type MutationVideoCreateArgs = {
  input: CreateVideoInput;
};

export type MutationVideoDeleteArgs = {
  videoId: Scalars["UUID"];
};

export type MutationWelcomePageUpdateArgs = {
  data: WelcomePageUpdateInput;
  welcomePageId: Scalars["String"];
};

export type MutationWordleConfigurationUpdateArgs = {
  data: WordleConfigurationUpdateInput;
  wordleConfigurationId: Scalars["String"];
};

export type MutationWordopolisConfigurationUpdateArgs = {
  data: WordopolisConfigurationUpdateInput;
  wordopolisConfigurationId: Scalars["String"];
};

export type Organization = {
  __typename?: "Organization";
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  manuallyManagedPlan?: Maybe<PlanName>;
  name: Scalars["String"];
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars["DateTime"];
};

/** The name of the Plan */
export enum PlanName {
  Admin = "ADMIN",
  Basic = "BASIC",
  Core = "CORE",
  Professional = "PROFESSIONAL",
  Teams = "TEAMS",
}

export type PortalSession = {
  __typename?: "PortalSession";
  url: Scalars["String"];
};

export type Project = {
  __typename?: "Project";
  createdAt: Scalars["DateTime"];
  customEndScreenConfiguration: CustomEndScreenConfiguration;
  directory: Directory;
  games: Array<Game>;
  hideDatagameBranding: Scalars["Boolean"];
  hideSummaryPage: Scalars["Boolean"];
  id: Scalars["UUID"];
  leaderboardConfiguration: LeaderboardConfiguration;
  name: Scalars["String"];
  organization: Organization;
  public: Scalars["Boolean"];
  showCustomEndScreen: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  status: ProjectStatus;
  updatedAt: Scalars["DateTime"];
};

export type ProjectPublic = {
  __typename?: "ProjectPublic";
  createdAt: Scalars["DateTime"];
  customEndScreenConfiguration: CustomEndScreenConfiguration;
  directory: Directory;
  games: Array<Game>;
  hideDatagameBranding: Scalars["Boolean"];
  hideSummaryPage: Scalars["Boolean"];
  id: Scalars["UUID"];
  leaderboardConfiguration: LeaderboardConfiguration;
  name: Scalars["String"];
  public: Scalars["Boolean"];
  showCustomEndScreen: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  status: ProjectStatus;
  updatedAt: Scalars["DateTime"];
};

/** The status of a project */
export enum ProjectStatus {
  Closed = "CLOSED",
  Draft = "DRAFT",
  Live = "LIVE",
}

export type ProjectUpdateInput = {
  directoryId?: InputMaybe<Scalars["UUID"]>;
  hideDatagameBranding?: InputMaybe<Scalars["Boolean"]>;
  hideSummaryPage?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  public?: InputMaybe<Scalars["Boolean"]>;
  showCustomEndScreen?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  status?: InputMaybe<Scalars["String"]>;
};

export type Query = {
  __typename?: "Query";
  directory: Directory;
  directoryList: Array<Directory>;
  game: Game;
  gameAll: Array<Game>;
  gameIsNicknameTaken: Scalars["Boolean"];
  gameLeaderboard: Array<LeaderboardRow>;
  gameLeaderboardResponseRank?: Maybe<LeaderboardRow>;
  getDemographicQuestions: Array<DemographicQuestion>;
  getDemographicResponses: Array<DemographicResponse>;
  libraryImageAll: Array<LibraryImage>;
  project: Project;
  projectIsNicknameTaken: Scalars["Boolean"];
  projectLeaderboard: Array<LeaderboardRow>;
  projectLeaderboardByNickname: LeaderboardRow;
  projectList: Array<Project>;
  projectPublic: ProjectPublic;
  quickRankGameResults: QuickRankGameResults;
  quickRankReport: QuickRankReport;
  quizConfiguration?: Maybe<QuizConfiguration>;
  quizReport: QuizReport;
  quizResponseReport: QuizResponseReport;
  quizSessionStats: QuizSessionStats;
  rankifierGameResults: RankifierGameResults;
  rankifierReport: RankifierReport;
  swiperGameResults: SwiperGameResults;
  swiperReport: SwiperReport;
  triviaReport: TriviaReport;
  triviaResponseReport: TriviaResponseReport;
  user: User;
  userList: Array<User>;
  userMe: User;
  wordleReport: WordleReport;
  wordopolisReport: WordopolisReport;
};

export type QueryDirectoryArgs = {
  directoryId: Scalars["UUID"];
};

export type QueryGameArgs = {
  gameId: Scalars["String"];
};

export type QueryGameAllArgs = {
  projectId: Scalars["String"];
};

export type QueryGameIsNicknameTakenArgs = {
  gameId: Scalars["String"];
  nickname: Scalars["String"];
};

export type QueryGameLeaderboardArgs = {
  gameId: Scalars["String"];
};

export type QueryGameLeaderboardResponseRankArgs = {
  responseId?: InputMaybe<Scalars["String"]>;
  responseSlug?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetDemographicResponsesArgs = {
  sessionId: Scalars["String"];
};

export type QueryProjectArgs = {
  projectId: Scalars["UUID"];
};

export type QueryProjectIsNicknameTakenArgs = {
  nickname: Scalars["String"];
  projectId: Scalars["String"];
};

export type QueryProjectLeaderboardArgs = {
  projectId: Scalars["String"];
};

export type QueryProjectLeaderboardByNicknameArgs = {
  nickname: Scalars["String"];
  projectId: Scalars["String"];
};

export type QueryProjectPublicArgs = {
  projectId: Scalars["UUID"];
};

export type QueryQuickRankGameResultsArgs = {
  responseId: Scalars["String"];
};

export type QueryQuickRankReportArgs = {
  gameId: Scalars["String"];
};

export type QueryQuizConfigurationArgs = {
  gameId: Scalars["UUID"];
};

export type QueryQuizReportArgs = {
  gameId: Scalars["String"];
};

export type QueryQuizResponseReportArgs = {
  gameId: Scalars["String"];
  responseId: Scalars["String"];
};

export type QueryQuizSessionStatsArgs = {
  quizConfigurationId: Scalars["String"];
};

export type QueryRankifierGameResultsArgs = {
  responseId: Scalars["String"];
};

export type QueryRankifierReportArgs = {
  gameId: Scalars["String"];
};

export type QuerySwiperGameResultsArgs = {
  responseId: Scalars["String"];
};

export type QuerySwiperReportArgs = {
  gameId: Scalars["String"];
};

export type QueryTriviaReportArgs = {
  gameId: Scalars["String"];
};

export type QueryTriviaResponseReportArgs = {
  gameId: Scalars["String"];
  responseId: Scalars["String"];
};

export type QueryUserArgs = {
  userId: Scalars["UUID"];
};

export type QueryWordleReportArgs = {
  gameId: Scalars["String"];
};

export type QueryWordopolisReportArgs = {
  gameId: Scalars["String"];
};

export type QuestionDropOffStat = {
  __typename?: "QuestionDropOffStat";
  completionRate: Scalars["Float"];
  dropOffRate: Scalars["Float"];
  questionIndex: Scalars["Int"];
  questionText: Scalars["String"];
  sessionsReaching: Scalars["Int"];
};

export type QuickRankAttributeResult = {
  __typename?: "QuickRankAttributeResult";
  attribute: Attribute;
  avgRank: Scalars["Float"];
  avgRating: Scalars["Float"];
};

export type QuickRankConfiguration = {
  __typename?: "QuickRankConfiguration";
  attributes: Array<Attribute>;
  createdAt: Scalars["DateTime"];
  feedbackPage: FeedbackPage;
  gameResults: GameResultsConfiguration;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  leaderboardConfiguration: LeaderboardConfiguration;
  mode: QuickRankMode;
  question: Scalars["String"];
  questionColor: Scalars["String"];
  ratingLeftLabel: Scalars["String"];
  ratingQuestion: Scalars["String"];
  ratingRightLabel: Scalars["String"];
  ratingScaleSize: Scalars["Int"];
  showFeedbackPage: Scalars["Boolean"];
  showGameResults: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  showRatingScale: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  shuffleCards: Scalars["Boolean"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
};

export type QuickRankConfigurationUpdateInput = {
  mode?: InputMaybe<QuickRankMode>;
  question?: InputMaybe<Scalars["String"]>;
  questionColor?: InputMaybe<Scalars["String"]>;
  ratingLeftLabel?: InputMaybe<Scalars["String"]>;
  ratingQuestion?: InputMaybe<Scalars["String"]>;
  ratingRightLabel?: InputMaybe<Scalars["String"]>;
  ratingScaleSize?: InputMaybe<Scalars["Int"]>;
  showFeedbackPage?: InputMaybe<Scalars["Boolean"]>;
  showGameResults?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  showRatingScale?: InputMaybe<Scalars["Boolean"]>;
  showWelcomePage?: InputMaybe<Scalars["Boolean"]>;
  shuffleCards?: InputMaybe<Scalars["Boolean"]>;
};

export type QuickRankGameResults = {
  __typename?: "QuickRankGameResults";
  match: Scalars["Int"];
};

/** The mode of the quick rank game */
export enum QuickRankMode {
  AllUp = "ALL_UP",
  Optimized = "OPTIMIZED",
  TwoPickN = "TWO_PICK_N",
}

export type QuickRankReport = {
  __typename?: "QuickRankReport";
  attributeResults: Array<QuickRankAttributeResult>;
  responseCount: Scalars["Int"];
  totalAttributes: Scalars["Int"];
};

export type QuickRankScore = {
  __typename?: "QuickRankScore";
  attribute: Attribute;
  count: Scalars["Int"];
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  rank: Scalars["Int"];
  rating: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
};

export type QuickRankScoreInput = {
  attributeId: Scalars["UUID"];
  count: Scalars["Int"];
  rank: Scalars["Int"];
  rating: Scalars["Int"];
};

export type QuizAnswerOption = {
  __typename?: "QuizAnswerOption";
  createdAt: Scalars["DateTime"];
  explanation: Scalars["String"];
  id: Scalars["UUID"];
  orderIndex: Scalars["Float"];
  points: Scalars["Float"];
  text: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type QuizConfiguration = {
  __typename?: "QuizConfiguration";
  createdAt: Scalars["DateTime"];
  enableTimer: Scalars["Boolean"];
  feedbackPage: FeedbackPage;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  leaderboardConfiguration: LeaderboardConfiguration;
  questions: Array<QuizQuestion>;
  showFeedbackPage: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  showResultsPage: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  timeToCompleteInSeconds: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
};

export type QuizQuestion = {
  __typename?: "QuizQuestion";
  answerOptions: Array<QuizAnswerOption>;
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  image?: Maybe<LibraryImage>;
  orderIndex: Scalars["Float"];
  question: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  video?: Maybe<Video>;
};

export type QuizQuestionScore = {
  __typename?: "QuizQuestionScore";
  answer: QuizAnswerOption;
  points: Scalars["Float"];
  question: QuizQuestion;
};

export type QuizQuestionScoreInput = {
  quizAnswerOptionId: Scalars["UUID"];
  quizQuestionId: Scalars["UUID"];
};

export type QuizReport = {
  __typename?: "QuizReport";
  demographicReport?: Maybe<DemographicReport>;
  questionResults: Array<QuizReportLine>;
  totalResponses: Scalars["Int"];
};

export type QuizReportLine = {
  __typename?: "QuizReportLine";
  question: QuizQuestion;
  scores: Array<AggregatedQuizQuestionScore>;
};

export type QuizResponseReport = {
  __typename?: "QuizResponseReport";
  scores: Array<QuizQuestionScore>;
  totalQuestions: Scalars["Int"];
  totalScore: Scalars["Float"];
};

export type QuizSession = {
  __typename?: "QuizSession";
  answeredQuestionsCount: Scalars["Int"];
  createdAt: Scalars["DateTime"];
  currentQuestionIndex: Scalars["Int"];
  demographicsCompleted: Scalars["Boolean"];
  id: Scalars["ID"];
  isCompleted: Scalars["Boolean"];
  lastActivityTime: Scalars["DateTime"];
  nickname?: Maybe<Scalars["String"]>;
  organizationId: Scalars["ID"];
  quizConfigurationId: Scalars["ID"];
  responseId?: Maybe<Scalars["ID"]>;
  startTime: Scalars["DateTime"];
  totalQuestionsCount: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
};

export type QuizSessionCreateInput = {
  nickname?: InputMaybe<Scalars["String"]>;
  quizConfigurationId: Scalars["ID"];
};

export type QuizSessionStats = {
  __typename?: "QuizSessionStats";
  averageQuestionsAnswered: Scalars["Float"];
  completedSessions: Scalars["Int"];
  completionRate: Scalars["Float"];
  demographicsCompletedSessions: Scalars["Int"];
  demographicsCompletionRate: Scalars["Float"];
  questionDropOffStats: Array<QuestionDropOffStat>;
  totalQuestions: Scalars["Int"];
  totalSessions: Scalars["Int"];
};

export type QuizSessionUpdateInput = {
  questionIndex: Scalars["Int"];
  quizAnswerOptionId: Scalars["ID"];
  quizQuestionId: Scalars["ID"];
  sessionId: Scalars["ID"];
};

export type RankifierAttributeResult = {
  __typename?: "RankifierAttributeResult";
  attribute: Attribute;
  minuses: Scalars["Int"];
  pluses: Scalars["Int"];
  score: Scalars["Int"];
};

export type RankifierConfiguration = {
  __typename?: "RankifierConfiguration";
  attributes: Array<Attribute>;
  cardsPerHand: Scalars["Int"];
  createdAt: Scalars["DateTime"];
  feedbackPage: FeedbackPage;
  gameResults: GameResultsConfiguration;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  leastQuestion: Scalars["String"];
  leastQuestionColor: Scalars["String"];
  mostQuestion: Scalars["String"];
  mostQuestionColor: Scalars["String"];
  numberOfRounds: Scalars["Int"];
  showFeedbackPage: Scalars["Boolean"];
  showGameResults: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
};

export type RankifierConfigurationUpdateInput = {
  cardsPerHand?: InputMaybe<Scalars["Int"]>;
  leastQuestion?: InputMaybe<Scalars["String"]>;
  leastQuestionColor?: InputMaybe<Scalars["String"]>;
  mostQuestion?: InputMaybe<Scalars["String"]>;
  mostQuestionColor?: InputMaybe<Scalars["String"]>;
  numberOfRounds?: InputMaybe<Scalars["Int"]>;
  showFeedbackPage?: InputMaybe<Scalars["Boolean"]>;
  showGameResults?: InputMaybe<Scalars["Boolean"]>;
  showWelcomePage?: InputMaybe<Scalars["Boolean"]>;
};

export type RankifierGameResults = {
  __typename?: "RankifierGameResults";
  match: Scalars["Int"];
};

export type RankifierReport = {
  __typename?: "RankifierReport";
  attributeResults: Array<RankifierAttributeResult>;
  totalResponses: Scalars["Int"];
};

export type RankifierScore = {
  __typename?: "RankifierScore";
  attribute: Attribute;
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  minuses: Scalars["Int"];
  plusses: Scalars["Int"];
  score: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
  zeroes: Scalars["Int"];
};

export type RankifierScoreInput = {
  attributeId: Scalars["UUID"];
  minuses: Scalars["Int"];
  plusses: Scalars["Int"];
  zeroes: Scalars["Int"];
};

export type Response = {
  __typename?: "Response";
  attributeScores: Array<AttributeScore>;
  createdAt: Scalars["DateTime"];
  endTime: Scalars["DateTime"];
  gameDuration?: Maybe<Scalars["Float"]>;
  id: Scalars["UUID"];
  nickname?: Maybe<Scalars["String"]>;
  quickRankScores: Array<QuickRankScore>;
  rankifierScores: Array<RankifierScore>;
  responseKind: ResponseKind;
  slug: Scalars["Int"];
  startTime: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export type ResponseCreateInput = {
  attributeScores?: InputMaybe<Array<AttributeScoreInput>>;
  endTime: Scalars["DateTime"];
  gameDuration?: InputMaybe<Scalars["Float"]>;
  gameId: Scalars["UUID"];
  nickname?: InputMaybe<Scalars["String"]>;
  quickRankScores?: InputMaybe<Array<QuickRankScoreInput>>;
  quizScores?: InputMaybe<Array<QuizQuestionScoreInput>>;
  rankifierScores?: InputMaybe<Array<RankifierScoreInput>>;
  responseKind?: InputMaybe<ResponseKind>;
  startTime: Scalars["DateTime"];
  triviaScores?: InputMaybe<Array<TriviaScoreInput>>;
  wordleScores?: InputMaybe<Array<WordleScoreInput>>;
  wordopolisScores?: InputMaybe<Array<WordopolisScoreInput>>;
};

/** Type of a response */
export enum ResponseKind {
  Alchemer = "ALCHEMER",
  Hosted = "HOSTED",
}

export type ScoreResult = {
  __typename?: "ScoreResult";
  count: Scalars["Int"];
  score: Scalars["Int"];
};

export type SignInResponse = {
  __typename?: "SignInResponse";
  accessToken: Scalars["String"];
};

export type SignUpInput = {
  email: Scalars["String"];
  password: Scalars["String"];
  token: Scalars["String"];
};

export type Subscription = {
  __typename?: "Subscription";
  createdAt: Scalars["DateTime"];
  currency: Scalars["String"];
  customerId: Scalars["String"];
  id: Scalars["UUID"];
  organization: Organization;
  planId: Scalars["String"];
  planName: PlanName;
  price: Scalars["Float"];
  priceInterval: Scalars["String"];
  status: Scalars["String"];
  subscriptionId: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type SwiperConfiguration = {
  __typename?: "SwiperConfiguration";
  attributes: Array<Attribute>;
  correctSwipeText: Scalars["String"];
  createdAt: Scalars["DateTime"];
  feedbackPage: FeedbackPage;
  gameResults: GameResultsConfiguration;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  incorrectSwipeText: Scalars["String"];
  leaderboardConfiguration: LeaderboardConfiguration;
  likeText: Scalars["String"];
  question: Scalars["String"];
  questionColor: Scalars["String"];
  showButtons: Scalars["Boolean"];
  showFeedbackPage: Scalars["Boolean"];
  showGameResults: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  showSwipeCorrectness: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  shuffleCards: Scalars["Boolean"];
  unlikeText: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
};

export type SwiperConfigurationUpdateInput = {
  correctSwipeText?: InputMaybe<Scalars["String"]>;
  incorrectSwipeText?: InputMaybe<Scalars["String"]>;
  likeText?: InputMaybe<Scalars["String"]>;
  question?: InputMaybe<Scalars["String"]>;
  questionColor?: InputMaybe<Scalars["String"]>;
  showButtons?: InputMaybe<Scalars["Boolean"]>;
  showFeedbackPage?: InputMaybe<Scalars["Boolean"]>;
  showGameResults?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  showSwipeCorrectness?: InputMaybe<Scalars["Boolean"]>;
  showWelcomePage?: InputMaybe<Scalars["Boolean"]>;
  shuffleCards?: InputMaybe<Scalars["Boolean"]>;
  unlikeText?: InputMaybe<Scalars["String"]>;
};

export type SwiperGameResults = {
  __typename?: "SwiperGameResults";
  match: Scalars["Int"];
};

export type SwiperReport = {
  __typename?: "SwiperReport";
  attributeResults: Array<AttributeResult>;
  totalResponses: Scalars["Int"];
};

export type TriviaAnswerOption = {
  __typename?: "TriviaAnswerOption";
  createdAt: Scalars["DateTime"];
  explanation: Scalars["String"];
  id: Scalars["UUID"];
  isCorrect: Scalars["Boolean"];
  points: Scalars["Int"];
  text: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type TriviaAnswerOptionCreateInput = {
  explanation?: InputMaybe<Scalars["String"]>;
  isCorrect?: InputMaybe<Scalars["Boolean"]>;
  points: Scalars["Int"];
  text: Scalars["String"];
};

export type TriviaAnswerOptionUpdateInput = {
  explanation?: InputMaybe<Scalars["String"]>;
  isCorrect?: InputMaybe<Scalars["Boolean"]>;
  points?: InputMaybe<Scalars["Int"]>;
  text?: InputMaybe<Scalars["String"]>;
};

export type TriviaConfiguration = {
  __typename?: "TriviaConfiguration";
  createdAt: Scalars["DateTime"];
  feedbackPage: FeedbackPage;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  leaderboardConfiguration: LeaderboardConfiguration;
  questions: Array<TriviaQuestion>;
  showFeedbackPage: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  timeToCompleteInSeconds: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
};

export type TriviaConfigurationUpdateInput = {
  showFeedbackPage?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  showWelcomePage?: InputMaybe<Scalars["Boolean"]>;
  timeToCompleteInSeconds?: InputMaybe<Scalars["Int"]>;
};

export type TriviaQuestion = {
  __typename?: "TriviaQuestion";
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  image?: Maybe<LibraryImage>;
  kind: TriviaQuestionType;
  options: Array<TriviaAnswerOption>;
  question: Scalars["String"];
  timeToCompleteInSeconds: Scalars["Int"];
  updatedAt: Scalars["DateTime"];
  video?: Maybe<Video>;
};

export type TriviaQuestionCreateInput = {
  options?: InputMaybe<Array<TriviaAnswerOptionCreateInput>>;
  question: Scalars["String"];
  timeToCompleteInSeconds?: InputMaybe<Scalars["Int"]>;
};

export type TriviaQuestionScore = {
  __typename?: "TriviaQuestionScore";
  answer: TriviaAnswerOption;
  isCorrect: Scalars["Boolean"];
  question: TriviaQuestion;
};

/** Type of a question */
export enum TriviaQuestionType {
  SingleChoice = "SINGLE_CHOICE",
}

export type TriviaQuestionUpdateInput = {
  imageId?: InputMaybe<Scalars["String"]>;
  question?: InputMaybe<Scalars["String"]>;
  timeToCompleteInSeconds?: InputMaybe<Scalars["Int"]>;
  videoId?: InputMaybe<Scalars["String"]>;
};

export type TriviaReport = {
  __typename?: "TriviaReport";
  questionResults: Array<TriviaReportLine>;
  totalResponses: Scalars["Int"];
};

export type TriviaReportLine = {
  __typename?: "TriviaReportLine";
  question: TriviaQuestion;
  scores: Array<AggregatedTriviaQuestionScore>;
};

export type TriviaResponseReport = {
  __typename?: "TriviaResponseReport";
  numberOfCorrectAnswers: Scalars["Int"];
  numberOfwrongAnswers: Scalars["Int"];
  scores: Array<TriviaQuestionScore>;
};

export type TriviaScoreInput = {
  timeInMs: Scalars["Int"];
  triviaAnswerOptionId: Scalars["UUID"];
  triviaQuestionId: Scalars["UUID"];
};

export type UpdateDirectoryInput = {
  name?: InputMaybe<Scalars["String"]>;
  parentDirectoryId?: InputMaybe<Scalars["UUID"]>;
};

export type User = {
  __typename?: "User";
  createdAt: Scalars["DateTime"];
  email: Scalars["String"];
  emailVerifiedAt?: Maybe<Scalars["DateTime"]>;
  firstName: Scalars["String"];
  id: Scalars["UUID"];
  lastName: Scalars["String"];
  organization: Organization;
  organizationId: Scalars["UUID"];
  role: UserRole;
  updatedAt: Scalars["DateTime"];
};

/** User roles */
export enum UserRole {
  Admin = "ADMIN",
  User = "USER",
}

export type UserUpdateInput = {
  companyName?: InputMaybe<Scalars["String"]>;
  firstName?: InputMaybe<Scalars["String"]>;
  lastName?: InputMaybe<Scalars["String"]>;
};

export type UserUpdatePasswordInput = {
  newPassword: Scalars["String"];
  oldPassword?: InputMaybe<Scalars["String"]>;
};

export type Video = {
  __typename?: "Video";
  createdAt: Scalars["DateTime"];
  extension: Scalars["String"];
  id: Scalars["UUID"];
  name: Scalars["String"];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars["UUID"]>;
  updatedAt: Scalars["DateTime"];
  url: Scalars["String"];
};

export type WelcomePage = {
  __typename?: "WelcomePage";
  backgroundColor: Scalars["String"];
  backgroundImage?: Maybe<LibraryImage>;
  button: Scalars["String"];
  buttonColor: Scalars["String"];
  createdAt: Scalars["DateTime"];
  id: Scalars["UUID"];
  logo?: Maybe<LibraryImage>;
  posterImage?: Maybe<LibraryImage>;
  subheading: Scalars["String"];
  subheadingColor: Scalars["String"];
  tagLine: Scalars["String"];
  tagLineColor: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  welcomeLine: Scalars["String"];
  welcomeLineColor: Scalars["String"];
};

export type WelcomePageUpdateInput = {
  backgroundColor?: InputMaybe<Scalars["String"]>;
  backgroundImageId?: InputMaybe<Scalars["UUID"]>;
  button?: InputMaybe<Scalars["String"]>;
  buttonColor?: InputMaybe<Scalars["String"]>;
  logoId?: InputMaybe<Scalars["UUID"]>;
  posterImageId?: InputMaybe<Scalars["UUID"]>;
  subheading?: InputMaybe<Scalars["String"]>;
  subheadingColor?: InputMaybe<Scalars["String"]>;
  tagLine?: InputMaybe<Scalars["String"]>;
  tagLineColor?: InputMaybe<Scalars["String"]>;
  welcomeLine?: InputMaybe<Scalars["String"]>;
  welcomeLineColor?: InputMaybe<Scalars["String"]>;
};

export type WordleConfiguration = {
  __typename?: "WordleConfiguration";
  createdAt: Scalars["DateTime"];
  feedbackPage: FeedbackPage;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  leaderboardConfiguration: LeaderboardConfiguration;
  numberOfTries: Scalars["Int"];
  showFeedbackPage: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
  word: Scalars["String"];
};

export type WordleConfigurationUpdateInput = {
  numberOfTries?: InputMaybe<Scalars["Int"]>;
  showFeedbackPage?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  showWelcomePage?: InputMaybe<Scalars["Boolean"]>;
  word?: InputMaybe<Scalars["String"]>;
};

export type WordleReport = {
  __typename?: "WordleReport";
  scoreResults: Array<ScoreResult>;
  totalResponses: Scalars["Int"];
};

export type WordleScoreInput = {
  score: Scalars["Int"];
};

export type WordopolisAttributeResult = {
  __typename?: "WordopolisAttributeResult";
  attribute: Attribute;
  avgRating: Scalars["Float"];
  avgScore: Scalars["Float"];
};

export type WordopolisConfiguration = {
  __typename?: "WordopolisConfiguration";
  attributes: Array<Attribute>;
  board: Array<Scalars["String"]>;
  boardBackgroundColor: Scalars["String"];
  boardBackgroundImage?: Maybe<LibraryImage>;
  boardColor: Scalars["String"];
  createdAt: Scalars["DateTime"];
  difficulty: WordopolisDifficulty;
  gameVisuals: GameVisuals;
  id: Scalars["UUID"];
  isTimeLimited: Scalars["Boolean"];
  leaderboardConfiguration: LeaderboardConfiguration;
  limitedTime: Scalars["Int"];
  name: Scalars["String"];
  numberOfColumns: Scalars["Int"];
  numberOfRows: Scalars["Int"];
  ratingLeftLabel: Scalars["String"];
  ratingQuestion: Scalars["String"];
  ratingRightLabel: Scalars["String"];
  ratingScaleSize: Scalars["Int"];
  showFeedbackPage: Scalars["Boolean"];
  showLeaderboard: Scalars["Boolean"];
  showRatingScale: Scalars["Boolean"];
  showWelcomePage: Scalars["Boolean"];
  showWords: Scalars["Boolean"];
  startText: Scalars["String"];
  topic: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  welcomePage: WelcomePage;
  words: Array<WordopolisWordDefinition>;
};

export type WordopolisConfigurationUpdateInput = {
  boardBackgroundColor?: InputMaybe<Scalars["String"]>;
  boardBackgroundImageId?: InputMaybe<Scalars["UUID"]>;
  boardColor?: InputMaybe<Scalars["String"]>;
  difficulty?: InputMaybe<WordopolisDifficulty>;
  isTimeLimited?: InputMaybe<Scalars["Boolean"]>;
  limitedTime?: InputMaybe<Scalars["Int"]>;
  name?: InputMaybe<Scalars["String"]>;
  numberOfColumns?: InputMaybe<Scalars["Int"]>;
  numberOfRows?: InputMaybe<Scalars["Int"]>;
  ratingLeftLabel?: InputMaybe<Scalars["String"]>;
  ratingQuestion?: InputMaybe<Scalars["String"]>;
  ratingRightLabel?: InputMaybe<Scalars["String"]>;
  ratingScaleSize?: InputMaybe<Scalars["Int"]>;
  showFeedbackPage?: InputMaybe<Scalars["Boolean"]>;
  showLeaderboard?: InputMaybe<Scalars["Boolean"]>;
  showRatingScale?: InputMaybe<Scalars["Boolean"]>;
  showWelcomePage?: InputMaybe<Scalars["Boolean"]>;
  showWords?: InputMaybe<Scalars["Boolean"]>;
  startText?: InputMaybe<Scalars["String"]>;
  topic?: InputMaybe<Scalars["String"]>;
};

/** Difficulty of the Wordopolis game */
export enum WordopolisDifficulty {
  Easy = "EASY",
  Hard = "HARD",
  Medium = "MEDIUM",
}

export type WordopolisReport = {
  __typename?: "WordopolisReport";
  attributeResults: Array<WordopolisAttributeResult>;
  totalResponses: Scalars["Int"];
};

export type WordopolisScoreInput = {
  attributeId: Scalars["UUID"];
  rating: Scalars["Int"];
  score: Scalars["Int"];
  time: Scalars["Int"];
};

export type WordopolisWordDefinition = {
  __typename?: "WordopolisWordDefinition";
  direction: Scalars["String"];
  startX: Scalars["Int"];
  startY: Scalars["Int"];
  value: Scalars["String"];
};

export type QuickRankConfigurationFragment = {
  __typename?: "QuickRankConfiguration";
  id: string;
  createdAt: string;
  updatedAt: string;
  mode: QuickRankMode;
  question: string;
  questionColor: string;
  ratingLeftLabel: string;
  ratingRightLabel: string;
  ratingQuestion: string;
  ratingScaleSize: number;
  showFeedbackPage: boolean;
  showGameResults: boolean;
  showRatingScale: boolean;
  showWelcomePage: boolean;
  showLeaderboard: boolean;
  shuffleCards: boolean;
  leaderboardConfiguration: {
    __typename?: "LeaderboardConfiguration";
    id: string;
    createdAt: string;
    updatedAt: string;
    header: string;
    headerColor: string;
    subheader: string;
    subheaderColor: string;
    showTimer: boolean;
    numberOfPlayers: number;
    nicknameQuestion: string;
    nicknameQuestionColor: string;
    nicknameLabel: string;
    tableNicknameLabel: string;
    tableScoreLabel: string;
    tableTimeLabel: string;
  };
  attributes: Array<{
    __typename?: "Attribute";
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    customText?: string | null;
    showImageAndText: boolean;
    image?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
    } | null;
  }>;
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    createdAt: string;
    updatedAt: string;
    themeColor: string;
    positiveColor: string;
    negativeColor: string;
    questionStringColor: string;
    cardStringColor: string;
    showIcons: boolean;
    backgroundColor: string;
    iconSet: IconSet;
    cardBackImage?: { __typename?: "LibraryImage"; id: string; url: string } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    createdAt: string;
    updatedAt: string;
    welcomeLine: string;
    welcomeLineColor: string;
    tagLine: string;
    tagLineColor: string;
    subheading: string;
    subheadingColor: string;
    button: string;
    buttonColor: string;
    backgroundColor: string;
    logo?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
    } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  feedbackPage: {
    __typename?: "FeedbackPage";
    id: string;
    createdAt: string;
    updatedAt: string;
    confirmation: string;
    confirmationColor: string;
    instructionLine: string;
    instructionLineColor: string;
    submitButton: string;
    submitButtonColor: string;
    textBoxPromptColor: string;
    textBoxPrompt: string;
    title: string;
    titleColor: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  gameResults: {
    __typename?: "GameResultsConfiguration";
    createdAt: string;
    id: string;
    scoreTag_0_20: string;
    scoreTag_21_40: string;
    scoreTag_41_60: string;
    scoreTag_61_80: string;
    scoreTag_81_100: string;
    scoreTitle_0_20: string;
    scoreTitle_21_40: string;
    scoreTitle_41_60: string;
    scoreTitle_61_80: string;
    scoreTitle_81_100: string;
    updatedAt: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
} & { " $fragmentName"?: "QuickRankConfigurationFragment" };

export type QuizConfigurationFragment = {
  __typename?: "QuizConfiguration";
  id: string;
  showWelcomePage: boolean;
  showFeedbackPage: boolean;
  showLeaderboard: boolean;
  showResultsPage: boolean;
  enableTimer: boolean;
  timeToCompleteInSeconds: number;
  questions: Array<{
    __typename?: "QuizQuestion";
    id: string;
    question: string;
    orderIndex: number;
    image?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    answerOptions: Array<{
      __typename?: "QuizAnswerOption";
      id: string;
      text: string;
      points: number;
      explanation: string;
      orderIndex: number;
    }>;
  }>;
  leaderboardConfiguration: {
    __typename?: "LeaderboardConfiguration";
    id: string;
    createdAt: string;
    updatedAt: string;
    header: string;
    headerColor: string;
    subheader: string;
    subheaderColor: string;
    showTimer: boolean;
    numberOfPlayers: number;
    nicknameQuestion: string;
    nicknameQuestionColor: string;
    nicknameLabel: string;
    tableNicknameLabel: string;
    tableScoreLabel: string;
    tableTimeLabel: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    themeColor: string;
    showIcons: boolean;
    iconSet: IconSet;
    backgroundColor: string;
    backgroundPositiveColor: string;
    backgroundNegativeColor: string;
    positiveColor: string;
    negativeColor: string;
    cardBackImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    welcomeLine: string;
    welcomeLineColor: string;
    subheading: string;
    subheadingColor: string;
    tagLine: string;
    tagLineColor: string;
    button: string;
    buttonColor: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    logo?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  feedbackPage: {
    __typename?: "FeedbackPage";
    id: string;
    title: string;
    titleColor: string;
    instructionLine: string;
    instructionLineColor: string;
    textBoxPrompt: string;
    textBoxPromptColor: string;
    submitButton: string;
    submitButtonColor: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
} & { " $fragmentName"?: "QuizConfigurationFragment" };

export type RankifierConfigurationFragment = {
  __typename?: "RankifierConfiguration";
  id: string;
  createdAt: string;
  updatedAt: string;
  showWelcomePage: boolean;
  showGameResults: boolean;
  showFeedbackPage: boolean;
  numberOfRounds: number;
  cardsPerHand: number;
  mostQuestion: string;
  mostQuestionColor: string;
  leastQuestion: string;
  leastQuestionColor: string;
  attributes: Array<{
    __typename?: "Attribute";
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    customText?: string | null;
    showImageAndText: boolean;
    image?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
    } | null;
  }>;
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    createdAt: string;
    updatedAt: string;
    themeColor: string;
    positiveColor: string;
    negativeColor: string;
    questionStringColor: string;
    cardStringColor: string;
    showIcons: boolean;
    backgroundPositiveColor: string;
    backgroundNegativeColor: string;
    iconSet: IconSet;
    cardBackImage?: { __typename?: "LibraryImage"; id: string; url: string } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    createdAt: string;
    updatedAt: string;
    welcomeLine: string;
    welcomeLineColor: string;
    tagLine: string;
    tagLineColor: string;
    subheading: string;
    subheadingColor: string;
    button: string;
    buttonColor: string;
    backgroundColor: string;
    logo?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
    } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  feedbackPage: {
    __typename?: "FeedbackPage";
    id: string;
    createdAt: string;
    updatedAt: string;
    confirmation: string;
    confirmationColor: string;
    instructionLine: string;
    instructionLineColor: string;
    submitButton: string;
    submitButtonColor: string;
    textBoxPromptColor: string;
    textBoxPrompt: string;
    title: string;
    titleColor: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  gameResults: {
    __typename?: "GameResultsConfiguration";
    createdAt: string;
    id: string;
    scoreTag_0_20: string;
    scoreTag_21_40: string;
    scoreTag_41_60: string;
    scoreTag_61_80: string;
    scoreTag_81_100: string;
    scoreTitle_0_20: string;
    scoreTitle_21_40: string;
    scoreTitle_41_60: string;
    scoreTitle_61_80: string;
    scoreTitle_81_100: string;
    updatedAt: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
} & { " $fragmentName"?: "RankifierConfigurationFragment" };

export type SwiperConfigurationFragment = {
  __typename?: "SwiperConfiguration";
  id: string;
  createdAt: string;
  updatedAt: string;
  shuffleCards: boolean;
  showWelcomePage: boolean;
  showGameResults: boolean;
  showFeedbackPage: boolean;
  showLeaderboard: boolean;
  questionColor: string;
  question: string;
  showButtons: boolean;
  showSwipeCorrectness: boolean;
  correctSwipeText: string;
  incorrectSwipeText: string;
  likeText: string;
  unlikeText: string;
  attributes: Array<{
    __typename?: "Attribute";
    id: string;
    name: string;
    customText?: string | null;
    createdAt: string;
    updatedAt: string;
    showImageAndText: boolean;
    isCorrect: boolean;
    image?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  }>;
  leaderboardConfiguration: {
    __typename?: "LeaderboardConfiguration";
    id: string;
    createdAt: string;
    updatedAt: string;
    header: string;
    headerColor: string;
    subheader: string;
    subheaderColor: string;
    showTimer: boolean;
    numberOfPlayers: number;
    nicknameQuestion: string;
    nicknameQuestionColor: string;
    nicknameLabel: string;
    tableNicknameLabel: string;
    tableScoreLabel: string;
    tableTimeLabel: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    createdAt: string;
    updatedAt: string;
    button: string;
    buttonColor: string;
    subheading: string;
    subheadingColor: string;
    tagLine: string;
    tagLineColor: string;
    welcomeLine: string;
    welcomeLineColor: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
    logo?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    createdAt: string;
    updatedAt: string;
    cardStringColor: string;
    negativeColor: string;
    positiveColor: string;
    questionStringColor: string;
    themeColor: string;
    showIcons: boolean;
    backgroundPositiveColor: string;
    backgroundNegativeColor: string;
    iconSet: IconSet;
    cardBackImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
    cardFrontImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  feedbackPage: {
    __typename?: "FeedbackPage";
    id: string;
    createdAt: string;
    updatedAt: string;
    confirmation: string;
    confirmationColor: string;
    instructionLine: string;
    instructionLineColor: string;
    submitButton: string;
    submitButtonColor: string;
    textBoxPromptColor: string;
    textBoxPrompt: string;
    title: string;
    titleColor: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  gameResults: {
    __typename?: "GameResultsConfiguration";
    createdAt: string;
    id: string;
    scoreTag_0_20: string;
    scoreTag_21_40: string;
    scoreTag_41_60: string;
    scoreTag_61_80: string;
    scoreTag_81_100: string;
    scoreTitle_0_20: string;
    scoreTitle_21_40: string;
    scoreTitle_41_60: string;
    scoreTitle_61_80: string;
    scoreTitle_81_100: string;
    updatedAt: string;
    backgroundColor: string;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
} & { " $fragmentName"?: "SwiperConfigurationFragment" };

export type TriviaConfigurationFragment = {
  __typename?: "TriviaConfiguration";
  id: string;
  timeToCompleteInSeconds: number;
  showFeedbackPage: boolean;
  showWelcomePage: boolean;
  showLeaderboard: boolean;
  questions: Array<{
    __typename?: "TriviaQuestion";
    id: string;
    createdAt: string;
    updatedAt: string;
    kind: TriviaQuestionType;
    question: string;
    timeToCompleteInSeconds: number;
    image?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    video?: { __typename?: "Video"; id: string; name: string; url: string } | null;
    options: Array<{
      __typename?: "TriviaAnswerOption";
      id: string;
      createdAt: string;
      updatedAt: string;
      text: string;
      isCorrect: boolean;
      points: number;
      explanation: string;
    }>;
  }>;
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    themeColor: string;
    showIcons: boolean;
    iconSet: IconSet;
    backgroundColor: string;
    backgroundPositiveColor: string;
    backgroundNegativeColor: string;
    positiveColor: string;
    negativeColor: string;
    cardBackImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  leaderboardConfiguration: {
    __typename?: "LeaderboardConfiguration";
    id: string;
    createdAt: string;
    updatedAt: string;
    header: string;
    headerColor: string;
    subheader: string;
    subheaderColor: string;
    showTimer: boolean;
    numberOfPlayers: number;
    nicknameQuestion: string;
    nicknameQuestionColor: string;
    nicknameLabel: string;
    tableNicknameLabel: string;
    tableScoreLabel: string;
    tableTimeLabel: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    welcomeLine: string;
    welcomeLineColor: string;
    subheading: string;
    subheadingColor: string;
    tagLine: string;
    tagLineColor: string;
    button: string;
    buttonColor: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    logo?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  feedbackPage: {
    __typename?: "FeedbackPage";
    id: string;
    title: string;
    titleColor: string;
    instructionLine: string;
    instructionLineColor: string;
    textBoxPrompt: string;
    textBoxPromptColor: string;
    submitButton: string;
    submitButtonColor: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
} & { " $fragmentName"?: "TriviaConfigurationFragment" };

export type WordleConfigurationFragment = {
  __typename?: "WordleConfiguration";
  id: string;
  createdAt: string;
  updatedAt: string;
  showFeedbackPage: boolean;
  showWelcomePage: boolean;
  word: string;
  numberOfTries: number;
  showLeaderboard: boolean;
  leaderboardConfiguration: {
    __typename?: "LeaderboardConfiguration";
    id: string;
    createdAt: string;
    updatedAt: string;
    header: string;
    headerColor: string;
    subheader: string;
    subheaderColor: string;
    showTimer: boolean;
    numberOfPlayers: number;
    nicknameQuestion: string;
    nicknameQuestionColor: string;
    nicknameLabel: string;
    tableNicknameLabel: string;
    tableScoreLabel: string;
    tableTimeLabel: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    themeColor: string;
    showIcons: boolean;
    iconSet: IconSet;
    backgroundColor: string;
    backgroundPositiveColor: string;
    backgroundNegativeColor: string;
    positiveColor: string;
    negativeColor: string;
    presentLetter: string;
    correctLetter: string;
    defaultLetter: string;
    absentLetter: string;
    cardBackImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    welcomeLine: string;
    welcomeLineColor: string;
    subheading: string;
    subheadingColor: string;
    tagLine: string;
    tagLineColor: string;
    button: string;
    buttonColor: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    logo?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  feedbackPage: {
    __typename?: "FeedbackPage";
    id: string;
    title: string;
    titleColor: string;
    instructionLine: string;
    instructionLineColor: string;
    textBoxPrompt: string;
    textBoxPromptColor: string;
    submitButton: string;
    submitButtonColor: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
} & { " $fragmentName"?: "WordleConfigurationFragment" };

export type WordopolisConfigurationFragment = {
  __typename?: "WordopolisConfiguration";
  createdAt: string;
  difficulty: WordopolisDifficulty;
  id: string;
  board: Array<string>;
  isTimeLimited: boolean;
  limitedTime: number;
  name: string;
  numberOfColumns: number;
  numberOfRows: number;
  ratingLeftLabel: string;
  ratingQuestion: string;
  ratingRightLabel: string;
  ratingScaleSize: number;
  showFeedbackPage: boolean;
  showRatingScale: boolean;
  showWelcomePage: boolean;
  showLeaderboard: boolean;
  showWords: boolean;
  startText: string;
  topic: string;
  updatedAt: string;
  boardBackgroundColor: string;
  boardColor: string;
  attributes: Array<{
    __typename?: "Attribute";
    id: string;
    name: string;
    createdAt: string;
    points: number;
    customText?: string | null;
    updatedAt: string;
    showImageAndText: boolean;
    customRatingQuestion?: {
      __typename?: "CustomRatingQuestion";
      question: string;
      leftLabel: string;
      rightLabel: string;
      scaleSize: number;
    } | null;
  }>;
  boardBackgroundImage?: { __typename?: "LibraryImage"; id: string; url: string; name: string } | null;
  leaderboardConfiguration: {
    __typename?: "LeaderboardConfiguration";
    id: string;
    createdAt: string;
    updatedAt: string;
    header: string;
    headerColor: string;
    subheader: string;
    subheaderColor: string;
    showTimer: boolean;
    numberOfPlayers: number;
    nicknameQuestion: string;
    nicknameQuestionColor: string;
    nicknameLabel: string;
    tableNicknameLabel: string;
    tableScoreLabel: string;
    tableTimeLabel: string;
    backgroundColor: string;
    backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
  };
  words: Array<{
    __typename?: "WordopolisWordDefinition";
    direction: string;
    startX: number;
    startY: number;
    value: string;
  }>;
  welcomePage: {
    __typename?: "WelcomePage";
    id: string;
    createdAt: string;
    updatedAt: string;
    button: string;
    buttonColor: string;
    subheading: string;
    subheadingColor: string;
    tagLine: string;
    tagLineColor: string;
    welcomeLine: string;
    welcomeLineColor: string;
    backgroundColor: string;
    logo?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
  gameVisuals: {
    __typename?: "GameVisuals";
    id: string;
    createdAt: string;
    updatedAt: string;
    cardStringColor: string;
    negativeColor: string;
    positiveColor: string;
    questionStringColor: string;
    themeColor: string;
    backgroundColor: string;
    cardBackImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
    cardFrontImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
    backgroundImage?: {
      __typename?: "LibraryImage";
      id: string;
      createdAt: string;
      updatedAt: string;
      url: string;
      extension: string;
      isGlobal: boolean;
      kind: LibraryImageKind;
      name: string;
    } | null;
  };
} & { " $fragmentName"?: "WordopolisConfigurationFragment" };

export type SubmitDemographicResponsesMutationVariables = Exact<{
  sessionId: Scalars["String"];
  responses: Array<DemographicResponseInput> | DemographicResponseInput;
}>;

export type SubmitDemographicResponsesMutation = {
  __typename?: "Mutation";
  submitDemographicResponses: Array<{
    __typename?: "DemographicResponse";
    id: string;
    questionId: string;
    textValue?: string | null;
    numberValue?: number | null;
    selectedOptionIds: Array<string>;
  }>;
};

export type GameAddRatingMutationVariables = Exact<{
  gameId: Scalars["String"];
  rating: Scalars["Int"];
}>;

export type GameAddRatingMutation = { __typename?: "Mutation"; gameAddRating: { __typename?: "Game"; id: string } };

export type ProjectDeleteDataMutationVariables = Exact<{
  projectId: Scalars["String"];
}>;

export type ProjectDeleteDataMutation = {
  __typename?: "Mutation";
  projectDeleteData: { __typename?: "Project"; id: string };
};

export type CreateQuizSessionMutationVariables = Exact<{
  data: QuizSessionCreateInput;
}>;

export type CreateQuizSessionMutation = {
  __typename?: "Mutation";
  createQuizSession: {
    __typename?: "QuizSession";
    id: string;
    quizConfigurationId: string;
    nickname?: string | null;
    startTime: string;
    currentQuestionIndex: number;
    totalQuestionsCount: number;
    answeredQuestionsCount: number;
  };
};

export type UpdateQuizSessionMutationVariables = Exact<{
  data: QuizSessionUpdateInput;
}>;

export type UpdateQuizSessionMutation = {
  __typename?: "Mutation";
  updateQuizSession: {
    __typename?: "QuizSession";
    id: string;
    currentQuestionIndex: number;
    answeredQuestionsCount: number;
    lastActivityTime: string;
  };
};

export type CompleteQuizSessionMutationVariables = Exact<{
  sessionId: Scalars["String"];
}>;

export type CompleteQuizSessionMutation = {
  __typename?: "Mutation";
  completeQuizSession: { __typename?: "QuizSession"; id: string; isCompleted: boolean; lastActivityTime: string };
};

export type ResponseCreateMutationVariables = Exact<{
  data: ResponseCreateInput;
}>;

export type ResponseCreateMutation = {
  __typename?: "Mutation";
  responseCreate: { __typename?: "Response"; id: string; slug: number };
};

export type GetDemographicQuestionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDemographicQuestionsQuery = {
  __typename?: "Query";
  getDemographicQuestions: Array<{
    __typename?: "DemographicQuestion";
    id: string;
    questionText: string;
    questionType: DemographicQuestionType;
    isRequired: boolean;
    orderIndex: number;
    answerOptions: Array<{
      __typename?: "DemographicAnswerOption";
      id: string;
      text: string;
      value: string;
      orderIndex: number;
    }>;
  }>;
};

export type GetDemographicResponsesQueryVariables = Exact<{
  sessionId: Scalars["String"];
}>;

export type GetDemographicResponsesQuery = {
  __typename?: "Query";
  getDemographicResponses: Array<{
    __typename?: "DemographicResponse";
    id: string;
    questionId: string;
    textValue?: string | null;
    numberValue?: number | null;
    selectedOptionIds: Array<string>;
  }>;
};

export type IsNicknameTakenQueryVariables = Exact<{
  nickname: Scalars["String"];
  gameId: Scalars["String"];
}>;

export type IsNicknameTakenQuery = { __typename?: "Query"; gameIsNicknameTaken: boolean };

export type GetLeaderboardQueryVariables = Exact<{
  gameId: Scalars["String"];
}>;

export type GetLeaderboardQuery = {
  __typename?: "Query";
  gameLeaderboard: Array<{
    __typename?: "LeaderboardRow";
    id: string;
    nickname: string;
    rank: number;
    timeInMs: number;
    points: number;
  }>;
};

export type GetCurrentRowQueryVariables = Exact<{
  responseId?: InputMaybe<Scalars["String"]>;
  responseSlug?: InputMaybe<Scalars["Int"]>;
}>;

export type GetCurrentRowQuery = {
  __typename?: "Query";
  currentRow?: {
    __typename?: "LeaderboardRow";
    id: string;
    nickname: string;
    rank: number;
    timeInMs: number;
    points: number;
  } | null;
};

export type ProjectPublicQueryVariables = Exact<{
  projectId: Scalars["UUID"];
}>;

export type ProjectPublicQuery = {
  __typename?: "Query";
  projectPublic: {
    __typename?: "ProjectPublic";
    id: string;
    name: string;
    status: ProjectStatus;
    hideDatagameBranding: boolean;
    hideSummaryPage: boolean;
    showLeaderboard: boolean;
    showCustomEndScreen: boolean;
    customEndScreenConfiguration: {
      __typename?: "CustomEndScreenConfiguration";
      id: string;
      mainHeader: string;
      mainHeaderColor: string;
      title: string;
      titleColor: string;
      description: string;
      descriptionColor: string;
      backgroundColor: string;
      logo?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
      backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    };
    leaderboardConfiguration: {
      __typename?: "LeaderboardConfiguration";
      id: string;
      createdAt: string;
      updatedAt: string;
      header: string;
      headerColor: string;
      subheader: string;
      subheaderColor: string;
      showTimer: boolean;
      numberOfPlayers: number;
      nicknameQuestion: string;
      nicknameQuestionColor: string;
      nicknameLabel: string;
      tableNicknameLabel: string;
      tableScoreLabel: string;
      tableTimeLabel: string;
      backgroundColor: string;
      backgroundImage?: { __typename?: "LibraryImage"; id: string; name: string; url: string } | null;
    };
    games: Array<{
      __typename?: "Game";
      id: string;
      kind: GameKind;
      name: string;
      responseCount: number;
      createdAt: string;
      updatedAt: string;
      configuration:
        | ({ __typename: "QuickRankConfiguration" } & {
            " $fragmentRefs"?: { QuickRankConfigurationFragment: QuickRankConfigurationFragment };
          })
        | ({ __typename: "QuizConfiguration" } & {
            " $fragmentRefs"?: { QuizConfigurationFragment: QuizConfigurationFragment };
          })
        | ({ __typename: "RankifierConfiguration" } & {
            " $fragmentRefs"?: { RankifierConfigurationFragment: RankifierConfigurationFragment };
          })
        | ({ __typename: "SwiperConfiguration" } & {
            " $fragmentRefs"?: { SwiperConfigurationFragment: SwiperConfigurationFragment };
          })
        | ({ __typename: "TriviaConfiguration" } & {
            " $fragmentRefs"?: { TriviaConfigurationFragment: TriviaConfigurationFragment };
          })
        | ({ __typename: "WordleConfiguration" } & {
            " $fragmentRefs"?: { WordleConfigurationFragment: WordleConfigurationFragment };
          })
        | ({ __typename: "WordopolisConfiguration" } & {
            " $fragmentRefs"?: { WordopolisConfigurationFragment: WordopolisConfigurationFragment };
          });
    }>;
  };
};

export type SwiperGameResultsQueryVariables = Exact<{
  responseId: Scalars["String"];
}>;

export type SwiperGameResultsQuery = {
  __typename?: "Query";
  swiperGameResults: { __typename?: "SwiperGameResults"; match: number };
};

export type RankifierGameResultsQueryVariables = Exact<{
  responseId: Scalars["String"];
}>;

export type RankifierGameResultsQuery = {
  __typename?: "Query";
  rankifierGameResults: { __typename?: "RankifierGameResults"; match: number };
};

export type QuickRankGameResultsQueryVariables = Exact<{
  responseId: Scalars["String"];
}>;

export type QuickRankGameResultsQuery = {
  __typename?: "Query";
  quickRankGameResults: { __typename?: "QuickRankGameResults"; match: number };
};

export type GetProjectLeaderboardQueryVariables = Exact<{
  projectId: Scalars["String"];
}>;

export type GetProjectLeaderboardQuery = {
  __typename?: "Query";
  projectLeaderboard: Array<{
    __typename?: "LeaderboardRow";
    id: string;
    nickname: string;
    rank: number;
    timeInMs: number;
    points: number;
  }>;
};

export type GetProjectLeaderboardCurrentRowQueryVariables = Exact<{
  projectId: Scalars["String"];
  nickname: Scalars["String"];
}>;

export type GetProjectLeaderboardCurrentRowQuery = {
  __typename?: "Query";
  currentRow: {
    __typename?: "LeaderboardRow";
    id: string;
    nickname: string;
    rank: number;
    timeInMs: number;
    points: number;
  };
};

export type IsProjectNicknameTakeQueryVariables = Exact<{
  nickname: Scalars["String"];
  projectId: Scalars["String"];
}>;

export type IsProjectNicknameTakeQuery = { __typename?: "Query"; projectIsNicknameTaken: boolean };

export const QuickRankConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuickRankConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuickRankConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "mode" } },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "questionColor" } },
          { kind: "Field", name: { kind: "Name", value: "ratingLeftLabel" } },
          { kind: "Field", name: { kind: "Name", value: "ratingRightLabel" } },
          { kind: "Field", name: { kind: "Name", value: "ratingQuestion" } },
          { kind: "Field", name: { kind: "Name", value: "ratingScaleSize" } },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "showGameResults" } },
          { kind: "Field", name: { kind: "Name", value: "showRatingScale" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
          { kind: "Field", name: { kind: "Name", value: "shuffleCards" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderboardConfiguration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheader" } },
                { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "customText" } },
                { kind: "Field", name: { kind: "Name", value: "showImageAndText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "questionStringColor" } },
                { kind: "Field", name: { kind: "Name", value: "cardStringColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "showIcons" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "iconSet" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "confirmation" } },
                { kind: "Field", name: { kind: "Name", value: "confirmationColor" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLine" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "submitButton" } },
                { kind: "Field", name: { kind: "Name", value: "submitButtonColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPromptColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPrompt" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_0_20" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_21_40" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_41_60" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_61_80" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_81_100" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_0_20" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_21_40" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_41_60" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_61_80" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_81_100" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuickRankConfigurationFragment, unknown>;
export const QuizConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QuizConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuizConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
          { kind: "Field", name: { kind: "Name", value: "showResultsPage" } },
          { kind: "Field", name: { kind: "Name", value: "enableTimer" } },
          { kind: "Field", name: { kind: "Name", value: "timeToCompleteInSeconds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "question" } },
                { kind: "Field", name: { kind: "Name", value: "orderIndex" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "points" } },
                      { kind: "Field", name: { kind: "Name", value: "explanation" } },
                      { kind: "Field", name: { kind: "Name", value: "orderIndex" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderboardConfiguration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheader" } },
                { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "showIcons" } },
                { kind: "Field", name: { kind: "Name", value: "iconSet" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundPositiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundNegativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLine" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPrompt" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPromptColor" } },
                { kind: "Field", name: { kind: "Name", value: "submitButton" } },
                { kind: "Field", name: { kind: "Name", value: "submitButtonColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuizConfigurationFragment, unknown>;
export const RankifierConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RankifierConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RankifierConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "showGameResults" } },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfRounds" } },
          { kind: "Field", name: { kind: "Name", value: "cardsPerHand" } },
          { kind: "Field", name: { kind: "Name", value: "mostQuestion" } },
          { kind: "Field", name: { kind: "Name", value: "mostQuestionColor" } },
          { kind: "Field", name: { kind: "Name", value: "leastQuestion" } },
          { kind: "Field", name: { kind: "Name", value: "leastQuestionColor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "customText" } },
                { kind: "Field", name: { kind: "Name", value: "showImageAndText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "questionStringColor" } },
                { kind: "Field", name: { kind: "Name", value: "cardStringColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "showIcons" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundPositiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundNegativeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "iconSet" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "confirmation" } },
                { kind: "Field", name: { kind: "Name", value: "confirmationColor" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLine" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "submitButton" } },
                { kind: "Field", name: { kind: "Name", value: "submitButtonColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPromptColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPrompt" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_0_20" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_21_40" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_41_60" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_61_80" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_81_100" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_0_20" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_21_40" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_41_60" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_61_80" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_81_100" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RankifierConfigurationFragment, unknown>;
export const SwiperConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SwiperConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SwiperConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "customText" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "showImageAndText" } },
                { kind: "Field", name: { kind: "Name", value: "isCorrect" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "shuffleCards" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "showGameResults" } },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
          { kind: "Field", name: { kind: "Name", value: "questionColor" } },
          { kind: "Field", name: { kind: "Name", value: "question" } },
          { kind: "Field", name: { kind: "Name", value: "showButtons" } },
          { kind: "Field", name: { kind: "Name", value: "showSwipeCorrectness" } },
          { kind: "Field", name: { kind: "Name", value: "correctSwipeText" } },
          { kind: "Field", name: { kind: "Name", value: "incorrectSwipeText" } },
          { kind: "Field", name: { kind: "Name", value: "likeText" } },
          { kind: "Field", name: { kind: "Name", value: "unlikeText" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderboardConfiguration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheader" } },
                { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardFrontImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cardStringColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "questionStringColor" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                { kind: "Field", name: { kind: "Name", value: "showIcons" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundPositiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundNegativeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "iconSet" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "confirmation" } },
                { kind: "Field", name: { kind: "Name", value: "confirmationColor" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLine" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "submitButton" } },
                { kind: "Field", name: { kind: "Name", value: "submitButtonColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPromptColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPrompt" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameResults" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_0_20" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_21_40" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_41_60" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_61_80" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTag_81_100" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_0_20" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_21_40" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_41_60" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_61_80" } },
                { kind: "Field", name: { kind: "Name", value: "scoreTitle_81_100" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwiperConfigurationFragment, unknown>;
export const TriviaConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TriviaConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TriviaConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "timeToCompleteInSeconds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "questions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "kind" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "video" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "question" } },
                { kind: "Field", name: { kind: "Name", value: "timeToCompleteInSeconds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "options" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "isCorrect" } },
                      { kind: "Field", name: { kind: "Name", value: "points" } },
                      { kind: "Field", name: { kind: "Name", value: "explanation" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "showIcons" } },
                { kind: "Field", name: { kind: "Name", value: "iconSet" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundPositiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundNegativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderboardConfiguration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheader" } },
                { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLine" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPrompt" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPromptColor" } },
                { kind: "Field", name: { kind: "Name", value: "submitButton" } },
                { kind: "Field", name: { kind: "Name", value: "submitButtonColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TriviaConfigurationFragment, unknown>;
export const WordleConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WordleConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WordleConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "word" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfTries" } },
          { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderboardConfiguration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheader" } },
                { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "showIcons" } },
                { kind: "Field", name: { kind: "Name", value: "iconSet" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundPositiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundNegativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "presentLetter" } },
                { kind: "Field", name: { kind: "Name", value: "correctLetter" } },
                { kind: "Field", name: { kind: "Name", value: "defaultLetter" } },
                { kind: "Field", name: { kind: "Name", value: "absentLetter" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "feedbackPage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLine" } },
                { kind: "Field", name: { kind: "Name", value: "instructionLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPrompt" } },
                { kind: "Field", name: { kind: "Name", value: "textBoxPromptColor" } },
                { kind: "Field", name: { kind: "Name", value: "submitButton" } },
                { kind: "Field", name: { kind: "Name", value: "submitButtonColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WordleConfigurationFragment, unknown>;
export const WordopolisConfigurationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WordopolisConfiguration" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WordopolisConfiguration" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "attributes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "points" } },
                { kind: "Field", name: { kind: "Name", value: "customText" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "showImageAndText" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customRatingQuestion" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "question" } },
                      { kind: "Field", name: { kind: "Name", value: "leftLabel" } },
                      { kind: "Field", name: { kind: "Name", value: "rightLabel" } },
                      { kind: "Field", name: { kind: "Name", value: "scaleSize" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "difficulty" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "board" } },
          { kind: "Field", name: { kind: "Name", value: "isTimeLimited" } },
          { kind: "Field", name: { kind: "Name", value: "limitedTime" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfColumns" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfRows" } },
          { kind: "Field", name: { kind: "Name", value: "ratingLeftLabel" } },
          { kind: "Field", name: { kind: "Name", value: "ratingQuestion" } },
          { kind: "Field", name: { kind: "Name", value: "ratingRightLabel" } },
          { kind: "Field", name: { kind: "Name", value: "ratingScaleSize" } },
          { kind: "Field", name: { kind: "Name", value: "showFeedbackPage" } },
          { kind: "Field", name: { kind: "Name", value: "showRatingScale" } },
          { kind: "Field", name: { kind: "Name", value: "showWelcomePage" } },
          { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
          { kind: "Field", name: { kind: "Name", value: "showWords" } },
          { kind: "Field", name: { kind: "Name", value: "startText" } },
          { kind: "Field", name: { kind: "Name", value: "topic" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "boardBackgroundColor" } },
          { kind: "Field", name: { kind: "Name", value: "boardColor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "boardBackgroundImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "leaderboardConfiguration" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "header" } },
                { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheader" } },
                { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "words" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "direction" } },
                { kind: "Field", name: { kind: "Name", value: "startX" } },
                { kind: "Field", name: { kind: "Name", value: "startY" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "welcomePage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "button" } },
                { kind: "Field", name: { kind: "Name", value: "buttonColor" } },
                { kind: "Field", name: { kind: "Name", value: "subheading" } },
                { kind: "Field", name: { kind: "Name", value: "subheadingColor" } },
                { kind: "Field", name: { kind: "Name", value: "tagLine" } },
                { kind: "Field", name: { kind: "Name", value: "tagLineColor" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLine" } },
                { kind: "Field", name: { kind: "Name", value: "welcomeLineColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "logo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "gameVisuals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardFrontImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cardStringColor" } },
                { kind: "Field", name: { kind: "Name", value: "negativeColor" } },
                { kind: "Field", name: { kind: "Name", value: "positiveColor" } },
                { kind: "Field", name: { kind: "Name", value: "questionStringColor" } },
                { kind: "Field", name: { kind: "Name", value: "themeColor" } },
                { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backgroundImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "extension" } },
                      { kind: "Field", name: { kind: "Name", value: "isGlobal" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WordopolisConfigurationFragment, unknown>;
export const SubmitDemographicResponsesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitDemographicResponses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "responses" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "DemographicResponseInput" } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitDemographicResponses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "responses" },
                value: { kind: "Variable", name: { kind: "Name", value: "responses" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "questionId" } },
                { kind: "Field", name: { kind: "Name", value: "textValue" } },
                { kind: "Field", name: { kind: "Name", value: "numberValue" } },
                { kind: "Field", name: { kind: "Name", value: "selectedOptionIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitDemographicResponsesMutation, SubmitDemographicResponsesMutationVariables>;
export const GameAddRatingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GameAddRating" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "gameId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "rating" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "gameAddRating" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "gameId" },
                value: { kind: "Variable", name: { kind: "Name", value: "gameId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "rating" },
                value: { kind: "Variable", name: { kind: "Name", value: "rating" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GameAddRatingMutation, GameAddRatingMutationVariables>;
export const ProjectDeleteDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProjectDeleteData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectDeleteData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProjectDeleteDataMutation, ProjectDeleteDataMutationVariables>;
export const CreateQuizSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateQuizSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "QuizSessionCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createQuizSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: { kind: "Variable", name: { kind: "Name", value: "data" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "quizConfigurationId" } },
                { kind: "Field", name: { kind: "Name", value: "nickname" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
                { kind: "Field", name: { kind: "Name", value: "currentQuestionIndex" } },
                { kind: "Field", name: { kind: "Name", value: "totalQuestionsCount" } },
                { kind: "Field", name: { kind: "Name", value: "answeredQuestionsCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateQuizSessionMutation, CreateQuizSessionMutationVariables>;
export const UpdateQuizSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateQuizSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "QuizSessionUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateQuizSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: { kind: "Variable", name: { kind: "Name", value: "data" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "currentQuestionIndex" } },
                { kind: "Field", name: { kind: "Name", value: "answeredQuestionsCount" } },
                { kind: "Field", name: { kind: "Name", value: "lastActivityTime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateQuizSessionMutation, UpdateQuizSessionMutationVariables>;
export const CompleteQuizSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CompleteQuizSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "completeQuizSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isCompleted" } },
                { kind: "Field", name: { kind: "Name", value: "lastActivityTime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteQuizSessionMutation, CompleteQuizSessionMutationVariables>;
export const ResponseCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResponseCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ResponseCreateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "responseCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: { kind: "Variable", name: { kind: "Name", value: "data" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResponseCreateMutation, ResponseCreateMutationVariables>;
export const GetDemographicQuestionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDemographicQuestions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDemographicQuestions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "questionText" } },
                { kind: "Field", name: { kind: "Name", value: "questionType" } },
                { kind: "Field", name: { kind: "Name", value: "isRequired" } },
                { kind: "Field", name: { kind: "Name", value: "orderIndex" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "answerOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "text" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "orderIndex" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDemographicQuestionsQuery, GetDemographicQuestionsQueryVariables>;
export const GetDemographicResponsesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDemographicResponses" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDemographicResponses" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "sessionId" },
                value: { kind: "Variable", name: { kind: "Name", value: "sessionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "questionId" } },
                { kind: "Field", name: { kind: "Name", value: "textValue" } },
                { kind: "Field", name: { kind: "Name", value: "numberValue" } },
                { kind: "Field", name: { kind: "Name", value: "selectedOptionIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDemographicResponsesQuery, GetDemographicResponsesQueryVariables>;
export const IsNicknameTakenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsNicknameTaken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "gameId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "gameIsNicknameTaken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "nickname" },
                value: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "gameId" },
                value: { kind: "Variable", name: { kind: "Name", value: "gameId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsNicknameTakenQuery, IsNicknameTakenQueryVariables>;
export const GetLeaderboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLeaderboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "gameId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "gameLeaderboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "gameId" },
                value: { kind: "Variable", name: { kind: "Name", value: "gameId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nickname" } },
                { kind: "Field", name: { kind: "Name", value: "rank" } },
                { kind: "Field", name: { kind: "Name", value: "timeInMs" } },
                { kind: "Field", name: { kind: "Name", value: "points" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLeaderboardQuery, GetLeaderboardQueryVariables>;
export const GetCurrentRowDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCurrentRow" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "responseSlug" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "currentRow" },
            name: { kind: "Name", value: "gameLeaderboardResponseRank" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "responseId" },
                value: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "responseSlug" },
                value: { kind: "Variable", name: { kind: "Name", value: "responseSlug" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nickname" } },
                { kind: "Field", name: { kind: "Name", value: "rank" } },
                { kind: "Field", name: { kind: "Name", value: "timeInMs" } },
                { kind: "Field", name: { kind: "Name", value: "points" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentRowQuery, GetCurrentRowQueryVariables>;
export const ProjectPublicDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProjectPublic" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectPublic" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "hideDatagameBranding" } },
                { kind: "Field", name: { kind: "Name", value: "hideSummaryPage" } },
                { kind: "Field", name: { kind: "Name", value: "showLeaderboard" } },
                { kind: "Field", name: { kind: "Name", value: "showCustomEndScreen" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "customEndScreenConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "mainHeader" } },
                      { kind: "Field", name: { kind: "Name", value: "mainHeaderColor" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "titleColor" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "descriptionColor" } },
                      { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "backgroundImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "leaderboardConfiguration" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "header" } },
                      { kind: "Field", name: { kind: "Name", value: "headerColor" } },
                      { kind: "Field", name: { kind: "Name", value: "subheader" } },
                      { kind: "Field", name: { kind: "Name", value: "subheaderColor" } },
                      { kind: "Field", name: { kind: "Name", value: "showTimer" } },
                      { kind: "Field", name: { kind: "Name", value: "numberOfPlayers" } },
                      { kind: "Field", name: { kind: "Name", value: "nicknameQuestion" } },
                      { kind: "Field", name: { kind: "Name", value: "nicknameQuestionColor" } },
                      { kind: "Field", name: { kind: "Name", value: "nicknameLabel" } },
                      { kind: "Field", name: { kind: "Name", value: "tableNicknameLabel" } },
                      { kind: "Field", name: { kind: "Name", value: "tableScoreLabel" } },
                      { kind: "Field", name: { kind: "Name", value: "tableTimeLabel" } },
                      { kind: "Field", name: { kind: "Name", value: "backgroundColor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "backgroundImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "games" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "kind" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "responseCount" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "configuration" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "QuickRankConfiguration" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "QuickRankConfiguration" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RankifierConfiguration" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "RankifierConfiguration" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SwiperConfiguration" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "SwiperConfiguration" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WordopolisConfiguration" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "WordopolisConfiguration" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "TriviaConfiguration" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "TriviaConfiguration" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "WordleConfiguration" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "WordleConfiguration" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: { kind: "NamedType", name: { kind: "Name", value: "QuizConfiguration" } },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "FragmentSpread", name: { kind: "Name", value: "QuizConfiguration" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...QuickRankConfigurationFragmentDoc.definitions,
    ...RankifierConfigurationFragmentDoc.definitions,
    ...SwiperConfigurationFragmentDoc.definitions,
    ...WordopolisConfigurationFragmentDoc.definitions,
    ...TriviaConfigurationFragmentDoc.definitions,
    ...WordleConfigurationFragmentDoc.definitions,
    ...QuizConfigurationFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<ProjectPublicQuery, ProjectPublicQueryVariables>;
export const SwiperGameResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SwiperGameResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "swiperGameResults" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "responseId" },
                value: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "match" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SwiperGameResultsQuery, SwiperGameResultsQueryVariables>;
export const RankifierGameResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RankifierGameResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rankifierGameResults" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "responseId" },
                value: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "match" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RankifierGameResultsQuery, RankifierGameResultsQueryVariables>;
export const QuickRankGameResultsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "QuickRankGameResults" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "quickRankGameResults" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "responseId" },
                value: { kind: "Variable", name: { kind: "Name", value: "responseId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "match" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuickRankGameResultsQuery, QuickRankGameResultsQueryVariables>;
export const GetProjectLeaderboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProjectLeaderboard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectLeaderboard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nickname" } },
                { kind: "Field", name: { kind: "Name", value: "rank" } },
                { kind: "Field", name: { kind: "Name", value: "timeInMs" } },
                { kind: "Field", name: { kind: "Name", value: "points" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectLeaderboardQuery, GetProjectLeaderboardQueryVariables>;
export const GetProjectLeaderboardCurrentRowDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProjectLeaderboardCurrentRow" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "currentRow" },
            name: { kind: "Name", value: "projectLeaderboardByNickname" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "nickname" },
                value: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "nickname" } },
                { kind: "Field", name: { kind: "Name", value: "rank" } },
                { kind: "Field", name: { kind: "Name", value: "timeInMs" } },
                { kind: "Field", name: { kind: "Name", value: "points" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectLeaderboardCurrentRowQuery, GetProjectLeaderboardCurrentRowQueryVariables>;
export const IsProjectNicknameTakeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsProjectNicknameTake" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
          type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "projectIsNicknameTaken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "nickname" },
                value: { kind: "Variable", name: { kind: "Name", value: "nickname" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "projectId" },
                value: { kind: "Variable", name: { kind: "Name", value: "projectId" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IsProjectNicknameTakeQuery, IsProjectNicknameTakeQueryVariables>;
